export function header() {
  const headerDropTop = document.querySelectorAll('.header-nav__top-dropdown')
  const headerBtnTop = document.querySelectorAll('.header__top-elem')
  const headerBottom = document.querySelector('.header__bottom')
  const headerTop = document.querySelector('.header__top')
  const headerNavItem = document.querySelectorAll('.header-nav__item')
  const wrapper = document.querySelector('.wrapper')
  const loginDropDown = document.querySelector('.header__login-dropdown')
  const header = document.querySelector('.header')
  const navWrapper = document.querySelector('.nav-region__wrapper')
  const bxPanel = document.querySelector('#bx-panel')
  if (bxPanel) {

    headerBottom.classList.add('header__bottom--translateY')
  }
  if (window.innerWidth < 1240 && headerBottom.classList.contains('header__bottom--translateY')) {
    headerBottom.classList.remove('header__bottom--translateY')
  }
  window.addEventListener('resize', () => {
    if (window.innerWidth > 1240 && header.classList.contains('header_open')) {
      header.classList.remove('header_open')
    } else if (
      window.innerWidth < 1240 &&
      !header.classList.contains('header_open') &&
      navWrapper.classList.contains('active') &&
      navWrapper.classList.contains('overlay-visible')

    ) {
      navWrapper.classList.remove('active')
      navWrapper.classList.remove('overlay-visible')
      header.classList.add('header_open')

    }
    if (window.innerWidth < 1240 && headerBottom.classList.contains('header__bottom--translateY')) {
      headerBottom.classList.remove('header__bottom--translateY')
    }
  })

  if (navWrapper) {

    navWrapper.classList.add('disabled')

    const observerHeader = new MutationObserver((mutations) => {
      for (let mutation of mutations) {
        if (mutation.attributeName == 'class' && mutation.target.classList.contains('header_open')) {
          navWrapper.classList.remove('disabled')
          if (navWrapper.classList.contains('active') && navWrapper.classList.contains('overlay-visible')) {
            navWrapper.classList.remove('active')
            navWrapper.classList.remove('overlay-visible')
          }
        } else if (mutation.attributeName == 'class' && !mutation.target.classList.contains('header_open')) {
          navWrapper.classList.add('disabled')
        }
      }
    })
    observerHeader.observe(header, {
      attributes: true,
    })
  }

  if (loginDropDown) {
    const container = document.createElement('div')
    const headerLoginModal = document.createElement('div')
    const modalOverlay = document.querySelector('.modal-overlay')

    container.classList.add('container', 'header-login-modal__container')
    loginDropDown.classList.add('header-login-modal__modal')
    headerLoginModal.classList.add('header-login-modal')

    const observer = new MutationObserver((mutations) => {
      for (let mutation of mutations) {
        if (mutation.attributeName == 'class' && mutation.target.classList.contains('visually-hidden')) {
          headerLoginModal.classList.remove('header-login-modal--z-index-max')
          document.body.append(modalOverlay)

        } else if (mutation.attributeName == 'class' && !mutation.target.classList.contains('visually-hidden')) {
          headerLoginModal.classList.add('header-login-modal--z-index-max')
          headerLoginModal.append(modalOverlay)
        }
      }

    })

    observer.observe(loginDropDown, {
      attributes: true,
    })

    container.append(loginDropDown)
    headerLoginModal.append(container)
    document.body.append(headerLoginModal)
  }
  if (headerDropTop) {

    headerDropTop.forEach(e => {
      const headerNavlevel3 = e.querySelector('.header-nav__list-level-3')
      const elem2 = e.querySelectorAll('.header-nav__elem-level-2')
      const elem3 = e.querySelectorAll('.header-nav__elem-level-3')
      const step = 44
      elem2.forEach((menuItem, menuIndex) => {
        const targetId = menuItem.dataset.changeMenu
        const targetElements = Array.from(elem3).filter(el => el.id === targetId)

        if (targetElements.length == 0) {
          menuItem.classList.add('empty')
          headerNavlevel3.classList.add('empty')
        }

        menuItem.addEventListener('mouseenter', () => {
          elem2.forEach(item => item.classList.remove('active'))
          if (targetElements.length == 0) {
            menuItem.classList.add('empty')
            headerNavlevel3.classList.add('empty')
          }
          elem3.forEach(item => {
            item.classList.remove('active')
            item.style.marginTop = ''
          })

          if (targetElements.length) {
            menuItem.classList.add('active')
            menuItem.classList.remove('empty')
            headerNavlevel3.classList.remove('empty')
            targetElements.forEach((el, index) => {
              el.classList.add('active')
              if (index === 0) {
                el.style.marginTop = `${menuIndex * step}px`
              }
            })
          }
        })
      })

    })
  }
  if (headerBtnTop) {
    headerBtnTop.forEach(e => {
      headerDropTop.forEach(e => {
        const elem2 = e.querySelectorAll('.header-nav__elem-level-2')
        const elem3 = e.querySelectorAll('.header-nav__elem-level-3')
        let targetChange = ''

        elem2.forEach((el, index) => {
          el.classList.remove('active')
          if (el && index == 0) {
            targetChange = el.dataset['changeMenu']
            el.classList.add('active')
          }
        })
        elem3.forEach((el, index) => {
          el.classList.remove('active')
          if (el && el.id == targetChange && index == 0) {
            el.classList.add('active')
          }
        })
      })
    })
  }

  function checkScroll() {
    const currentScroll = window.scrollY
    const shouldAddClass = currentScroll >= 300
    const shouldRemoveClass = currentScroll <= 200
    const hasClassBgScroll = headerBottom.classList.contains('header__bottom--bg-scroll')
    const hasClassFixed = header.classList.contains('header--fixed')
    const hasClassHeaderTopHidden = headerTop.classList.contains('header__top--hidden')
    const hasClassHeaderBottomScroll = headerTop.classList.contains('header__bottom--bg-scroll')

    if (shouldAddClass && !hasClassBgScroll && hasClassFixed) {
      headerBottom.classList.add('header__bottom--bg-scroll')
      headerTop.classList.add('header__top--hidden')

    } else if (shouldRemoveClass && hasClassBgScroll && hasClassFixed) {
      headerBottom.classList.remove('header__bottom--bg-scroll')
      headerTop.classList.remove('header__top--hidden')
    }

    if (shouldAddClass && !hasClassFixed) {
      headerTop.classList.add('header__top--hidden')
    } else if (shouldRemoveClass && !hasClassFixed) {
      headerTop.classList.remove('header__top--hidden')
    }
  }



  if (window) {
    checkScroll()
    window.addEventListener('scroll', () => requestAnimationFrame(checkScroll))
  }


  if (headerBottom) {
    headerBottom.addEventListener('mouseenter', () => {

      if (!headerBottom.classList.contains('header__bottom--bg-hover')) {
        headerBottom.classList.add('header__bottom--bg-hover')
      }
    }, { 'capture': true })
    headerBottom.addEventListener('mouseleave', () => {
      if (window.scrollY < 100 && headerBottom.classList.contains('header__bottom--bg-hover')) {
        headerBottom.classList.remove('header__bottom--bg-hover')
      }
    })
  }
  if (headerNavItem && headerBottom) {
    headerNavItem.forEach(e => {
      e.addEventListener('mouseenter', () => {
        if (!headerBottom.classList.contains('header__bottom--bg-hover')) {
          headerBottom.classList.add('header__bottom--bg-hover')
        }
      })

      e.addEventListener('mouseleave', () => {
        if (window.scrollY < 100 && headerBottom.classList.contains('header__bottom--bg-hover')) {
          headerBottom.classList.remove('header__bottom--bg-hover')
        }
      })
    }, { 'capture': true })
  }


}
